import { defineMessages } from '@jutro/locale';

export default defineMessages({
    DateOfBirth: {
        id: 'ml.gateway.views.account-landing.contacts.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    PrimaryAddress: {
        id: 'ml.gateway.views.account-landing.contacts.Primary Address',
        defaultMessage: 'Primary Address'
    },
    Primary: {
        id: 'ml.gateway.views.account-landing.contacts.(Primary)',
        defaultMessage: '(Primary)'
    },
    Edit: {
        id: 'ml.gateway.views.account-landing.contacts.Edit',
        defaultMessage: 'Edit'
    },
    Save: {
        id: 'ml.gateway.views.account-landing.contacts.Save',
        defaultMessage: 'Save'
    },
    Cancel: {
        id: 'ml.gateway.views.account-landing.contacts.Cancel',
        defaultMessage: 'Cancel'
    },
    EditContactDetails: {
        id: 'ml.gateway.views.account-landing.contacts.Edit Contact Details',
        defaultMessage: 'Edit Contact Details: '
    },
    saving: {
        id: 'ml.gateway.views.account-landing.contacts.Saving',
        defaultMessage: 'Saving your changes'
    },
    error: {
        id: 'ml.gateway.views.account-landing.contacts.Error',
        defaultMessage: 'Error'
    },
    noAccount: {
        id: 'ml.gateway.views.account-landing.contacts.Could not find an Account with Account Number',
        defaultMessage: 'Could not find an Account with Account Number: {accountNumber}'
    }
})